const { createStore } = require('./Store');
const { MitraReducer } = require('./Reducers');
const { MitraState } = require('./States');
const { MitraActions } = require('./Actions');

const [MitraProvider, useMitraDispatch, useMitraStore] = createStore(
  MitraReducer,
  MitraState,
  MitraActions
);
export { MitraProvider, useMitraDispatch, useMitraStore };
